export class BranchOffices {
    constructor(public data: {
        Id?: Number,
        Name?: String,
        Agency?: Boolean
    }) { }
}